import { Form, Input } from 'antd';
import PhoneInput from 'components/PhoneInput';
import styled from 'styled-components';
import useInquiryCustomer from '../BookingOnlineV2/useInquiryCustomer';

const CustomerStep = () => {
  const form = Form.useFormInstance();
  const [, inquiry] = useInquiryCustomer({
    onStart() {
      form.resetFields(['customerId', 'customerName']);
    },
    onDone(data) {
      form.setFieldValue('customerId', data?.id);
      form.setFieldValue('customerName', data?.name);
    },
  });

  const handleChangePhone = async (e: any) => {
    form.resetFields(['CUSTOMER_VALID']);
    await inquiry(e?.target?.value || '');
  };

  const handleChangeCustomerName = async (e: any) => {
    form.resetFields(['CUSTOMER_VALID']);
  };

  return (
    <Container>
      <InputsContainer>
        <div className='title-wrap'>
          <p className='title'>
            Customer
          </p>
        </div>

        <Form.Item
          label="Phone number"
          name="customerPhone"
          rules={[{ required: true, message: 'Please enter your phone number' }]}
        >
          <PhoneInput
            isNormal
            placeholder="(000)000-0000"
            onChange={handleChangePhone}
          />
        </Form.Item>

        <Form.Item
          label="Full Name"
          name="customerName"
          rules={[{ required: true, message: 'Please enter your full name' }]}
        >
          <Input
            placeholder="Please enter"
            onChange={handleChangeCustomerName}
          />
        </Form.Item>
      </InputsContainer>
    </Container>
  );
};

export default CustomerStep;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex-shrink: 0;
  background: #fff;
  min-height: 100vh;
  align-self: stretch;
  .title-wrap {
    align-self: stretch;
  }
  .ShopInfo {
    width: 100%;
    align-self: stretch;
  }
  p.title {
    align-self: stretch;
    color: #1D2129;
    text-align: center;
    font-family: Poppins;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }
`;

const InputsContainer = styled.div`
display: flex;
flex-direction: column;
align-items: flex-start;
padding: 0 16px;
align-self: stretch;
`;